import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["id", "content", "autoHideDuration"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import ReactDOM from 'react-dom';
import PubSub from '../tools/PubSub';
var MESSAGE_ADD = 'MESSAGE_ADD';
var MESSAGE_DEL = 'MESSAGE_DEL';
var pubSub = new PubSub();
var MessageComponent;
var uid = Date.now();
var messageContainer;

function init(Message) {
  MessageComponent = Message;
}
/**
 * 创建静态 message 的容器元素
 * @param {Function} callback
 */


function createMessageContainer(callback) {
  messageContainer = document.createElement('div');
  messageContainer.classList.add('jmtd-static-message-container');
  document.body.appendChild(messageContainer);
  ReactDOM.render( /*#__PURE__*/React.createElement(StaticMessageWrap, null), messageContainer, function () {
    return callback();
  });
}
/**
 * 打开一个弹窗
 * @param {FullMessageOptions} options
 * @returns {any} id
 */


function open(options) {
  options = _objectSpread(_objectSpread({}, options), {}, {
    id: uid++,
    open: false
  });

  if (!messageContainer) {
    createMessageContainer(function () {
      pubSub.publish(MESSAGE_ADD, options);
    });
  } else {
    pubSub.publish(MESSAGE_ADD, options);
  }

  return options.id;
}
/**
 * 弹出 Message 的静态方法的参数
 * @typedef MessageOptions
 * @property {any} [title]
 * @property {any} [content]
 * @property {number} [autoHideDuration]
 */

/**
 * 提示消息
 * @param {MessageOptions} options
 * @returns
 */


function info(options) {
  return open(_objectSpread(_objectSpread({}, options), {}, {
    type: 'info'
  }));
}
/**
 * 成功消息
 * @param {MessageOptions} options
 * @returns
 */


function success(options) {
  return open(_objectSpread(_objectSpread({}, options), {}, {
    type: 'success'
  }));
}
/**
 * 帮助消息
 * @param {MessageOptions} options
 * @returns
 */


function help(options) {
  return open(_objectSpread(_objectSpread({}, options), {}, {
    type: 'help'
  }));
}
/**
 * 警告消息
 * @param {MessageOptions} options
 * @returns
 */


function warning(options) {
  return open(_objectSpread(_objectSpread({}, options), {}, {
    type: 'warning'
  }));
}
/**
 * 危险消息
 * @param {MessageOptions} options
 * @returns
 */


function danger(options) {
  return open(_objectSpread(_objectSpread({}, options), {}, {
    type: 'danger'
  }));
}
/**
 * 加载中消息
 * @param {MessageOptions} options
 * @returns
 */


function loading(options) {
  return open(_objectSpread(_objectSpread({}, options), {}, {
    type: 'loading'
  }));
}
/**
 * 关闭一个弹窗
 * @param {number} id
 */


function close(id) {
  pubSub.publish(MESSAGE_DEL, id);
}
/**
 * 弹出 Message 的参数
 * @typedef FullMessageOptions
 * @property {any} [id]
 * @property {'info'|'success'|'help'|'warning'|'danger'|'loading'} type
 * @property {any} title
 * @property {any} [content]
 * @property {boolean} open
 * @property {number} [autoHideDuration]
 */

/**
 * 静态 message 的包装组件
 */


var StaticMessageWrap = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(StaticMessageWrap, _React$PureComponent);

  var _super = _createSuper(StaticMessageWrap);

  function StaticMessageWrap(props) {
    var _this;

    _classCallCheck(this, StaticMessageWrap);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "addMessage", function (options) {
      _this.setState(function (state) {
        return {
          messages: state.messages.concat(options)
        };
      }, function () {
        // 为了执行动画，延迟设置 open: true
        setTimeout(function () {
          _this.setState(function (state) {
            return {
              messages: state.messages.map(function (item) {
                if (item.id === options.id) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    open: true
                  });
                }

                return item;
              })
            };
          });
        }, 10);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "delMessage", function (id) {
      _this.setState(function (state) {
        return {
          messages: state.messages.filter(function (item) {
            return item.id !== id;
          })
        };
      });
    });

    _this.state = {
      messages: []
    };
    return _this;
  }

  _createClass(StaticMessageWrap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      pubSub.subscribe(MESSAGE_ADD, this.addMessage);
      pubSub.subscribe(MESSAGE_DEL, this.delMessage);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      pubSub.unsubscribe(MESSAGE_ADD, this.addMessage);
      pubSub.unsubscribe(MESSAGE_DEL, this.delMessage);
    }
    /**
     * 添加一个 message 消息
     * @param {FullMessageOptions} options message 参数
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var messages = this.state.messages;
      return /*#__PURE__*/React.createElement(React.Fragment, null, messages.map(function (_ref) {
        var id = _ref.id,
            content = _ref.content,
            _ref$autoHideDuration = _ref.autoHideDuration,
            autoHideDuration = _ref$autoHideDuration === void 0 ? 3000 : _ref$autoHideDuration,
            rest = _objectWithoutProperties(_ref, _excluded);

        return /*#__PURE__*/React.createElement(MessageComponent, _extends({
          key: id,
          autoHideDuration: autoHideDuration
        }, rest, {
          onClose: function onClose() {
            return _this2.delMessage(id);
          }
        }), content);
      }));
    }
  }]);

  return StaticMessageWrap;
}(React.PureComponent);

export { init, open, info, success, help, warning, danger, loading, close };